import React from 'react';

interface DataLoadingSkeletonProps {
  message?: string;
  submessage?: string;
}

const DataLoadingSkeleton: React.FC<DataLoadingSkeletonProps> = ({ 
  message = 'Carregando dados', 
  submessage = 'Aguarde enquanto buscamos os dados...' 
}) => {
  return (
    <div className="text-center py-20 bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl border border-white/20">
      <div className="space-y-6">
        <div className="flex justify-center">
          <div className="w-16 h-16 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin"></div>
        </div>
        <div>
          <h3 className="text-xl font-semibold text-gray-900 mb-2">{message}</h3>
          <p className="text-gray-600">{submessage}</p>
        </div>
      </div>
    </div>
  );
};

export default DataLoadingSkeleton;
